import * as Yup from "yup";

export const formDataObject = {
  rcNumber: "",
};

export const validationSchema = Yup.object().shape({
  rcNumber: Yup.string().required("This field is required."),
});
